'use strict';

import { appendQueryParams } from '../utils';

export default (API) => ({
    headOffices: {
        getAll: () => {
            const url = 'v3/headOffices';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAvailable: () => {
            const url = 'v3/headOffices/available';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        create: (params) => {
            const url = 'v3/headOffices';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        update: (headOfficeId, params) => {
            const url = 'v3/headOffices/' + headOfficeId;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        delete: (headOfficeId) => {
            const url = 'v3/headOffices/' + headOfficeId;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        getHeadOfficesBanks: (params) => {
            let url = 'v3/headOffices/banks';
            url = appendQueryParams(url, params);
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getHeadOfficeBanks: (headOfficeId) => {
            const url = `v3/headOffices/${headOfficeId}/banks`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getHeadOfficeBankVersions: (headOfficeId, bankId) => {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/versions`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createHeadOfficeBank: (headOfficeId, params) => {
            const url = `v3/headOffices/${headOfficeId}/banks`;
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateHeadOfficeBank: (headOfficeId, bankId, params) => {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateHeadOfficeBankVersion: (headOfficeId, bankId, versionId, params) => {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/versions/${versionId}`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteHeadOfficeBank: (headOfficeId, bankId) => {
            const url = 'v3/headOffices/' + headOfficeId + '/banks/' + bankId;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        deleteHeadOfficeBankVersion: (headOfficeId, bankId, versionId) => {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/versions/${versionId}`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        getHeadOfficeBankNotes: (headOfficeId, bankId) => {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/notes`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        createHeadOfficeBankNote(headOfficeId, bankId, params) {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/note`;
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateHeadOfficeBankNote(headOfficeId, bankId, noteId, params) {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/note/${noteId}`;
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteHeadOfficeBankNote: (headOfficeId, bankId, noteId) => {
            const url = `v3/headOffices/${headOfficeId}/banks/${bankId}/note/${noteId}`;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
    },
});
